(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dot-custom-portrait"]) return;
  try {
    
  function initializePortraitUploads(root) {
    root.querySelectorAll('input[data-portrait-photo]').forEach((input) => {
      if (input.dataset.initialized) return;
      input.dataset.initialized = 'true';
      const form = input.closest('form');
      const preview = form.querySelector('[data-portrait-preview]');
      const error = form.querySelector('[data-portrait-error]');
      let previewUrl;
      input.addEventListener('change', () => {
        if (previewUrl) URL.revokeObjectURL(previewUrl);
        preview.hidden = true;
        preview.removeAttribute('src');
        error.textContent = '';
        input.setCustomValidity('');
        const file = input.files[0];
        if (!file) return;
        if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type) || file.size > 10 * 1024 * 1024) {
          const message = 'Choose a JPG, PNG or WebP image no larger than 10 MB.';
          input.setCustomValidity(message);
          error.textContent = message;
          input.value = '';
          return;
        }
        previewUrl = URL.createObjectURL(file);
        preview.src = previewUrl;
        preview.hidden = false;
      });
    });
  }
  initializePortraitUploads(document);
  document.addEventListener('shopify:section:load', (event) => initializePortraitUploads(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dot-design-requirement"]) return;
  try {
    
function initializeDotDesignGuard() {
  const form = document.querySelector('main form[action$="/cart/add"]');
  const helper = document.querySelector('[data-dot-design-help]');
  if (!form || !helper || form.dataset.dotDesignGuard) return;
  form.dataset.dotDesignGuard = 'true';
  const button = form.querySelector('button[name="add"]');
  if (!button) return;
  const productSection = form.closest('.shopify-section') || form.parentElement;
  let gateDisabled = false;
  let scheduled = false;
  const hasDesign = () => {
    const input = form.querySelector('input[name="properties[Personalization ID]"]');
    return Boolean(input && input.value && input.value.trim());
  };
  const update = () => {
    scheduled = false;
    const ready = hasDesign();
    productSection.classList.toggle('dot-diy-awaiting-design', !ready);
    helper.hidden = ready;
    if (!ready && !button.disabled) {
      gateDisabled = true;
      button.disabled = true;
    } else if (ready && gateDisabled) {
      gateDisabled = false;
      button.disabled = false;
    }
    const personalizeButton = productSection.querySelector('button[id^="personalize-button-"]');
    if (personalizeButton && helper.previousElementSibling !== personalizeButton) personalizeButton.after(helper);
  };
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(update);
  };
  const observer = new MutationObserver(schedule);
  observer.observe(productSection, {subtree:true,childList:true,attributes:true,attributeFilter:['value','disabled']});
  form.addEventListener('submit', (event) => {
    if (hasDesign()) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    helper.hidden = false;
    productSection.querySelector('button[id^="personalize-button-"]')?.focus();
  }, true);
  document.addEventListener('change', schedule);
  window.addEventListener('message', (event) => {
    if (event.origin === 'https://personalize.at') schedule();
  });
  update();
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeDotDesignGuard);
else initializeDotDesignGuard();
document.addEventListener('shopify:section:load', initializeDotDesignGuard);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dot-diy-portal"]) return;
  try {
    
  function initializeDiyPortals(root) {
    root.querySelectorAll('.dot-diy form').forEach((form) => {
      if (form.dataset.diyInitialized) return;
      form.dataset.diyInitialized = 'true';
      const input = form.querySelector('[data-diy-photo]');
      const preview = form.querySelector('[data-diy-preview]');
      const error = form.querySelector('[data-diy-error]');
      const submit = form.querySelector('[data-diy-submit]');
      const mockupPhoto = form.querySelector('[data-diy-mockup-photo]');
      const placeholder = form.querySelector('[data-diy-placeholder]');
      const garment = form.querySelector('[data-diy-garment]');
      const mockupName = form.querySelector('[data-diy-mockup-name]');
      const petName = form.querySelector('input[name="properties[Pet name]"]');
      petName.addEventListener('input', () => { mockupName.textContent = petName.value.slice(0, 24); });
      let previewUrl;
      input.addEventListener('change', () => {
        if (previewUrl) URL.revokeObjectURL(previewUrl);
        preview.hidden = true;
        preview.removeAttribute('src');
        mockupPhoto.removeAttribute('href');
        mockupPhoto.style.display = 'none';
        placeholder.style.display = '';
        error.textContent = '';
        input.setCustomValidity('');
        const file = input.files[0];
        if (!file) return;
        if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type) || file.size > 10 * 1024 * 1024) {
          const message = 'Choose a JPG, PNG or WebP image no larger than 10 MB.';
          input.setCustomValidity(message);
          error.textContent = message;
          input.value = '';
          return;
        }
        previewUrl = URL.createObjectURL(file);
        preview.src = previewUrl;
        preview.hidden = false;
        mockupPhoto.setAttribute('href', previewUrl);
        mockupPhoto.style.display = '';
        placeholder.style.display = 'none';
      });
      const updateSelection = () => {
        let available = false;
        form.querySelectorAll('[data-diy-card]').forEach((card) => {
          const radio = card.querySelector('[data-diy-choice]');
          const select = card.querySelector('[data-diy-variant]');
          select.disabled = !radio.checked;
          const option = select.selectedOptions[0];
          if (option) card.querySelector('[data-diy-price]').textContent = option.dataset.price;
          if (radio.checked && option) {
            const colour = option.textContent.toLowerCase();
            let fill = '#f7f5ef';
            if (colour.includes('black')) fill = '#232428';
            else if (colour.includes('heather')) fill = '#aaa9a5';
            else if (colour.includes('pink')) fill = '#f0b7ca';
            garment.setAttribute('fill', fill);
            mockupName.setAttribute('fill', colour.includes('black') ? '#fff' : '#252b25');
            if (option.dataset.available === 'true') available = true;
          }
        });
        submit.disabled = !available || form.dataset.productionReady !== 'true';
      };
      form.querySelectorAll('[data-diy-choice], [data-diy-variant]').forEach((control) => control.addEventListener('change', updateSelection));
      const availableRadio = form.querySelector('[data-diy-choice]:not(:disabled)');
      if (availableRadio) availableRadio.checked = true;
      updateSelection();
    });
  }
  initializeDiyPortals(document);
  document.addEventListener('shopify:section:load', (event) => initializeDiyPortals(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
